/**
 * workflowStageDoneBody.tsx — Stage/Route 完成态展开体（仅 AgentLoopView 时间线）
 *
 * 禁止用 content_blocks 原始预览充展开体（会与 AgentSession 折叠流不一致）。
 */
import { hasTimelineNodes } from '../../core/workflow/loopTreeUtils';
import type { SessionTree } from '../../types/tree';
import type { WorkflowContainerRuntimeNode } from '../../types/workflowContainer';
import { AgentLoopView } from '../agentLoop/AgentLoopView';

export interface WorkflowStageDoneBodyProps {
  node: WorkflowContainerRuntimeNode;
  loopTree?: SessionTree;
  testId: string;
  virtualized?: boolean;
  virtualizeThreshold?: number;
  groupParallelTools?: boolean;
  bodyClassName?: string;
}

export function WorkflowStageDoneBody({
  loopTree,
  testId,
  virtualized,
  virtualizeThreshold,
  groupParallelTools,
  bodyClassName = 'lax-workflow-stage-container__body',
}: WorkflowStageDoneBodyProps) {
  if (loopTree && hasTimelineNodes(loopTree)) {
    return (
      <div className={bodyClassName} data-testid={testId}>
        <AgentLoopView
          tree={loopTree}
          showTaskListFooter={false}
          virtualized={virtualized}
          virtualizeThreshold={virtualizeThreshold}
          groupParallelTools={groupParallelTools}
        />
      </div>
    );
  }

  return (
    <div
      className={`${bodyClassName} lax-workflow-stage-container__empty-hint`}
      data-testid={testId}
    >
      <span className="lax-workflow-stage-container__empty-hint-text">
        （此阶段暂无 Agent 时间线内容）
      </span>
    </div>
  );
}
